import { IKameleoonData, KCSType, KCSDataType, KameleoonData } from './types';
import { TrackingStatus } from 'src/types';

/**
 * @class
 * KameleoonConversionScore - a class for creating an KCS Heat Range data
 * */
export class KameleoonConversionScore implements IKameleoonData {
  public status: TrackingStatus;

  private kcs: KCSType;

  /**
   * @param {KCSType} kcs - Kameleoon Conversion Score nested object
   * */
  constructor(kcs: KCSType) {
    this.kcs = kcs;
    this.status = TrackingStatus.Sent;
  }

  get url(): string {
    return '';
  }

  get data(): KCSDataType {
    return {
      kcs: this.kcs,
      type: KameleoonData.KameleoonConversionScore,
      status: this.status,
    };
  }
}
